(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reviews-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const shuffleGrid = (grid) => {
      if (grid.dataset.reviewsShuffled === 'true') return;

      const cards = [...grid.querySelectorAll(':scope > [data-review-card]')];
      for (let index = cards.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [cards[index], cards[randomIndex]] = [cards[randomIndex], cards[index]];
      }

      const fragment = document.createDocumentFragment();
      cards.forEach((card) => fragment.append(card));
      grid.append(fragment);
      grid.dataset.reviewsShuffled = 'true';
    };

    const initializeReviewGrids = (root = document) => {
      root.querySelectorAll('[data-reviews-grid]').forEach(shuffleGrid);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeReviewGrids(), { once: true });
    } else {
      initializeReviewGrids();
    }

    document.addEventListener('shopify:section:load', (event) => initializeReviewGrids(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
